import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';

import { DownloadIcon } from '../../theme/AthenaIcons';
import PermissionChecker, { permissionType } from '../permissions/PermissionChecker';

import { observable, action } from 'mobx';
import { observer } from "mobx-react";


const fileExts= ['xlsx','csv']

@observer
class DataFrameDownload extends React.Component {
  @observable anchorEl = null;

  static propTypes = {
    href: PropTypes.string.isRequired,
    permission: permissionType,
    disabled: PropTypes.bool,
    tooltipText: PropTypes.string,
    buttonConfig: PropTypes.object,
    urlConfig: PropTypes.string,
  };

  static defaultProps = {
    permission: true,
    disabled: false,
    tooltipText: 'Download',
    buttonConfig: {
      type: 'default',
      class: '',
    },
    urlConfig: '',
  };


  @action handleOpen = event => this.anchorEl = event.currentTarget;

  @action close = () => this.anchorEl = null;

  open = () => {return Boolean(this.anchorEl)}


  renderList = (hasPermission, ext, key) => {
    const { href, urlConfig } = this.props;
    const apiUrl = href + urlConfig +`&export=${ext}`
    return (
      <ListItem 
        key={key} 
        button 
        onClick={()=>this.close()}
        component='a' 
        href={hasPermission? apiUrl : '#'}
      >
        <ListItemText primary={ext.toUpperCase()} />
      </ListItem>
    )
  }

  renderNode = (hasPermission) => {
    const { disabled, buttonConfig } = this.props;
    const isDisabled = !hasPermission || disabled;
    switch(buttonConfig.type){
      case "text":
        return (
          <span>
            <Button
              className={buttonConfig.class}
              disabled={isDisabled}
              variant="contained"
              size="small"
              fullWidth
              startIcon={<DownloadIcon disabled={isDisabled} size={17} strokeWidth={4}  />}
              onClick={(event) => this.handleOpen(event)}
            >
              Download
            </Button>
          </span>
        )

      default:
        return (
          <IconButton
            component="a"
            onClick={(event) => this.handleOpen(event)}
            disabled={isDisabled}
          >
            <DownloadIcon />
          </IconButton>
        )
    }
  }


  render() {
    const { permission, tooltipText } = this.props;
    const anchorOpen = this.anchorEl;
    return (
      <PermissionChecker permission={permission}>
        { 
          hasPermission => 
            <>
              <Tooltip title={tooltipText}>
                {this.renderNode(hasPermission)}
              </Tooltip>
              <Popover
                open={this.open()}
                anchorEl={anchorOpen}
                onClose={() => this.close()}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
              >
                <List disablePadding>
                  {fileExts.map((ext, key) => this.renderList(hasPermission,ext, key))}
                </List>
            </Popover>
          </>
        }
      </PermissionChecker>
    );
  }
}

export default DataFrameDownload;
